import {AnalyticsEvent, GAEventParameters} from "./AnalyticsEventTypes";
import {router} from "../../../router";
import {getMobileOrientation, isInMobileApp, isInMobileDevice, isInOldCordovaApp} from "../../../utils/MobileUtils";

export function prepareEventParameters(event: AnalyticsEvent) {
  return Object.assign({}, event.parameters ?? getDefaultEventProperties(), event.additionalParameters);
}
function getDefaultEventProperties(): object {
  let eventProperties = {
    version: process.env.VERSION
  } as any;

  if (isInMobileDevice()) {
    eventProperties = {
      ...eventProperties,
      mobileOrientation: getMobileOrientation(),
      isInCordovaApp: isInOldCordovaApp(),
      isInMobileApp: isInMobileApp()
    }
  }

  if ('playableId' in router.currentRoute.params) {
    return {
      ...eventProperties,
      playableType: router.currentRoute.params.playableType,
      playableId: router.currentRoute.params.playableId,
      artist: router.currentRoute.params.artist,
      title: router.currentRoute.params.songname,
    };
  }
  else {
    return eventProperties;
  }
}

export function getGAEventParametersFromAnalyticsEvent(event: AnalyticsEvent): GAEventParameters {
  let eventLabel = '';
  if (event.parameters) {
    if (event.gaLabelIdentifier && event.parameters[event.gaLabelIdentifier]) {
      eventLabel = event.parameters[event.gaLabelIdentifier];
    }
    else if (event.parameters.idversion) { // TODO: Will be removed
      eventLabel = event.parameters.idversion;
    }
    else if (event.parameters.playableId) {
      eventLabel = event.parameters.playableType + '_' + event.parameters.playableId;
    }
  }

  return {
    event_category: event.category,
    event_label: eventLabel,
  };
}
